import { t } from 'i18next'
import { clearAuth, updateAuthError } from '@/containers/Login/AuthSlice'

export const IP_NOT_ALLOWED_CODE = 'ip_not_allowed'

const HTTP_FORBIDDEN = 403

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null

export const ipNotAllowedMessage = (status: number, data: unknown): string | null => {
  const error = isRecord(data) ? data.error : null
  if (!isRecord(error) || status !== HTTP_FORBIDDEN || error.code !== IP_NOT_ALLOWED_CODE) {
    return null
  }

  return typeof error.message === 'string' && error.message !== '' ? error.message : t('common:ip_not_allowed')
}

export const ipNotAllowedActions = (status: number, data: unknown) => {
  const message = ipNotAllowedMessage(status, data)

  return message === null ? null : [clearAuth(), { type: updateAuthError.type, payload: message }]
}
